<script>
export default {
    name: "BatchesPrint",

    data() {

        return {
            batches: [],
        };
    },

    computed: {

        totalBillAmount() {
            if(!this.batches.length) return 0;

            return this.batches.map(batch => parseFloat(batch.bill_Amount))
                .reduce((sum, amt) => sum+amt);
        },

        totalPaidAmount() {
            if(!this.batches.length) return 0;

            return this.batches.map(batch => parseFloat(batch.paid))
                .reduce((sum, amt) => sum+amt);
        },

        totalBalanceAmount() {
            if(!this.batches.length) return 0;

            return this.batches.map(batch => parseFloat(batch.balance))
                .reduce((sum, amt) => sum+amt);
        },
    },

    mounted() {
        this.$root.loading=true;
        Promise.allSettled([ this.fetchBatches(), ]).then(() => {
            this.$root.loading=false;
            setTimeout(() => {
                window.print();
            }, 250);
        }).catch(() => { this.$root.loading=false; });
    },

    methods: {

        fetchBatches() {

            let url = `Accounts/GetOrganizationBatches`;
                url += `?Datefrom=${this.$route.query.DateFrom}`;
                url += `&Dateto=${this.$route.query.DateTo}`;
                url += this.$route.query.Search ? `&SearchText=${this.$route.query.Search}` : ``;

            return this.$http.get(url).then(response => {
                    this.batches = response.data;
                }).catch(() => {});
        },
    },
}
</script>
<template>
    <div class="flex flex-wrap w-full">
        <tail-address-header></tail-address-header>
        <div class="w-full text-center my-2">
            <h5 class="text-base font-bold uppercase">Batches</h5>
        </div>
        <table class="table">
            <thead class="text-sm">
                <tr class="flex w-full">
                    <th class="p-tiny flex-1">No</th>
                    <th class="p-tiny flex-1">Date</th>
                    <th class="p-tiny flex-1">Organization</th>
                    <th class="p-tiny flex-1">Batch No</th>
                    <th class="p-tiny flex-1">Batch Amount</th>
                    <th class="p-tiny flex-1">Paid</th>
                    <th class="p-tiny flex-1">Balance</th>
                    <th class="p-tiny flex-1">Memo</th>
                    <th class="p-tiny flex-1">Batched By</th>
                </tr>
            </thead>
            <tbody class="text-xs flex flex-col items-center w-full">
                <tr class="flex w-full" v-for="(batch,idx) in batches" :key="idx">
                    <td class="p-tiny flex-1">{{ idx+1 }}</td>
                    <td class="p-tiny flex-1">{{ batch.batchDate | dateFormat }}</td>
                    <td class="p-tiny flex-1">{{ batch.organization }}</td>
                    <td class="p-tiny flex-1">{{ batch.batchNo }}</td>
                    <td class="p-tiny flex-1">{{ batch.bill_Amount | numberFormat }}</td>
                    <td class="p-tiny flex-1">{{ batch.paid | numberFormat }}</td>
                    <td class="p-tiny flex-1">{{ batch.balance | numberFormat }}</td>
                    <td class="p-tiny flex-1">{{ batch.batchMemo }}</td>
                    <td class="p-tiny flex-1">{{ batch.batchedBy || `-` }}</td>
                </tr>
                <tr class="w-full flex">
                    <th colspan="5" class="p-tiny flex-1"></th>
                    <th class="p-tiny flex-1">
                        Batches: {{ batches.length }}</th>
                    <th class="p-tiny flex-1">
                        Total Balance: {{ totalBalanceAmount | numberFormat }}</th>
                    <th class="p-tiny flex-1"> 
                        Total Paid: {{ totalPaidAmount | numberFormat }}
                    </th>
                    <th class="p-tiny flex-1">
                        Total Bill: {{ totalBillAmount | numberFormat }}
                    </th>
                </tr>
            </tbody>
        </table>
        <div class="w-full p-tiny">
            <p class="text-xs">
                From: {{ this.$route.query.DateFrom }} to {{ this.$route.query.DateTo }}.
            </p>
        </div>
    </div>
</template>